<script setup lang="ts">
useHead({ title: 'CV | Kathiravan K | Sr.Fullstack Developer' })
</script>

<template>
  <div>
    <iframe
      title="Kathiravan Resume"
      :style="{ width: '100%', height: '800px' }"
      src="/Kathiravan_K_Resume_UI_Updated.pdf"
    />
  </div>
</template>
